import React, { Component } from "react";

class BouncyBanner extends Component {
  render() {
    return (
      <div>
        <div className="preparing-quote bouncy-banner">
          <div>
            <div className="card-spinner">
              <div className="bounce1" />
              <div className="bounce2" />
              <div className="bounce3" />
            </div>
            <div className="text">{this.props.bannerText}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default BouncyBanner;
